import React from "react"
import Info, { FontSize } from "./Info"

interface IOwnProps {
    size?: FontSize
    value: string
    src?: string
}

type Props = IOwnProps

const Website: React.FC<Props> = (props) => {
    const { size = "medium", value, src = value } = props

    return (
        <Info type="website" size={ size } value={ value } link={ true } />
    )
}

export default Website
